import type { EditorView } from '@codemirror/view'

export const wrapContent = (editorView: EditorView | null, before: string, after = before) => {
  if (!editorView) return
  const { from, to } = editorView.state.selection.main
  const doc = editorView.state.sliceDoc(0)

  let start = from
  let end = to

  if (start === end) {
    while (start > 0 && doc[start - 1] !== ' ' && doc[start - 1] !== '\n') start--
    while (end < doc.length && doc[end] !== ' ' && doc[end] !== '\n') end++
  }

  const selectedText = doc.slice(start, end)
  const isWrapped =
    doc.slice(start - before.length, start) === before &&
    doc.slice(end, end + after.length) === after

  const newText = isWrapped ? selectedText : `${before}${selectedText}${after}`

  const changeStart = isWrapped ? start - before.length : start
  const changeEnd = isWrapped ? end + after.length : end
  const anchor = isWrapped ? changeStart : start + before.length
  const head = isWrapped ? anchor + selectedText.length : start + newText.length - after.length

  editorView.dispatch({
    changes: { from: changeStart, to: changeEnd, insert: newText },
    selection: { anchor, head }
  })
  editorView.focus()
}

export const insertBulletList = (editorView: EditorView | null) => {
  if (!editorView) return
  const { from, to } = editorView.state.selection.main
  const doc = editorView.state.sliceDoc(0)

  let start = from
  let end = to

  if (start === end) {
    while (start > 0 && doc[start - 1] !== '\n') start--
    while (end < doc.length && doc[end] !== '\n') end++
  }

  const lines = doc.slice(start, end).split('\n')
  const newText = lines.map(line => `- ${line}`).join('\n')

  editorView.dispatch({
    changes: { from: start, to: end, insert: newText },
    selection: { anchor: start + 2, head: start + 2 }
  })
  editorView.focus()
}

export const insertNumberedList = (editorView: EditorView | null) => {
  if (!editorView) return
  const { from, to } = editorView.state.selection.main
  const doc = editorView.state.sliceDoc(0)

  let start = from
  let end = to

  if (start === end) {
    while (start > 0 && doc[start - 1] !== '\n') start--
    while (end < doc.length && doc[end] !== '\n') end++
  }

  const lines = doc.slice(start, end).split('\n')
  const newText = lines.map((line, i) => `${i + 1}. ${line}`).join('\n')

  editorView.dispatch({
    changes: { from: start, to: end, insert: newText },
    selection: { anchor: start + `${1}. `.length, head: start + `${1}. `.length }
  })
  editorView.focus()
}

export const insertLink = (editorView: EditorView | null) => {
  if (!editorView) return
  const { from, to } = editorView.state.selection.main
  const markdown = `[tekst](url)`
  editorView.dispatch({
    changes: { from, to, insert: markdown },
    selection: { anchor: from + 1 + 'tekst'.length, head: from + 1 + 'tekst'.length }
  })
  editorView.focus()
}

export const insertImage = (editorView: EditorView | null) => {
  if (!editorView) return
  const { from, to } = editorView.state.selection.main
  const html = `<img src="" width="300" height="200" alt="image" />`
  editorView.dispatch({
    changes: { from, to, insert: html },
    selection: { anchor: from + `<img src="`.length, head: from + `<img src="`.length }
  })
  editorView.focus()
}

export const insertEquation = (editorView: EditorView | null) => {
  if (!editorView) return

  const { from, to } = editorView.state.selection.main
  const placeholder = '$$\n a^2 + b^2 = c^2 \n$$'

  const cursorPos = placeholder.lastIndexOf('\n$$')

  editorView.dispatch({
    changes: { from, to, insert: placeholder },
    selection: { anchor: from + cursorPos, head: from + cursorPos }
  })
  editorView.focus()
}

export const insertDeepDiveCard = (editorView: EditorView | null) => {
  if (!editorView) return
  const { from, to } = editorView.state.selection.main
  const jsx = `<DeepDive title='Tytuł sekcji'> 
  Zawartość sekcji... 
</DeepDive>`

  editorView.dispatch({
    changes: { from, to, insert: jsx },
    selection: { anchor: from + jsx.length, head: from + jsx.length }
  })
  editorView.focus()
}

export const insertContentCard = (editorView: EditorView | null) => {
  if (!editorView) return
  const { from, to } = editorView.state.selection.main
  const jsx = `<ContentCard title="Tytuł sekcji">
    - Pierwszy punkt listy
    - Drugi punkt listy
    - Trzeci punkt listy
</ContentCard>`

  editorView.dispatch({
    changes: { from, to, insert: jsx },
    selection: { anchor: from + jsx.length, head: from + jsx.length }
  })
  editorView.focus()
}

export const insertFocusCard = (editorView: EditorView | null) => {
  if (!editorView) return
  const { from, to } = editorView.state.selection.main
  const jsx = `<FocusCard title='Tytuł sekcji'> 
  Zawartość sekcji...
</FocusCard>`

  editorView.dispatch({
    changes: { from, to, insert: jsx },
    selection: { anchor: from + jsx.length, head: from + jsx.length }
  })
  editorView.focus()
}
